import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Home, FileText, LogOut } from 'lucide-react';
import { getAuth, clearAuth } from '@/lib/auth';
import WebchatWidget from '@/components/WebchatWidget';

export default function ClientLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();

  const handleLogout = () => {
    clearAuth();
    navigate('/login');
  };

  return (
    <div className="min-h-screen" data-testid="client-layout">
      {/* Header */}
      <header className="sticky top-0 z-20 bg-[rgba(11,15,20,0.85)] backdrop-blur border-b border-white/10">
        <div className="mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
          <button onClick={() => navigate('/client')} className="flex items-center gap-2">
            <img src="/logo-recupnet.png" alt="RecupNet" className="h-8" />
          </button>
          <div className="flex items-center gap-4">
            <span className="text-sm text-white/60 hidden sm:block">{auth?.user?.name}</span>
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 rounded-xl px-3 py-2 text-sm text-white/60 hover:text-white hover:bg-white/[0.04] transition-colors"
              data-testid="client-logout-button"
            >
              <LogOut size={16} /> Sair
            </button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <Outlet />
      </main>
      <WebchatWidget />
    </div>
  );
}
